import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { SabloaneService } from '../sabloane.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { initializeEditor } from 'src/app/utils/editorConfig';

@Component({
    selector: 'app-add-sabloane',
    templateUrl: './add-sabloane.component.html',
    styleUrls: ['./add-sabloane.component.scss'],
})
export class AddSabloaneComponent implements OnInit {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    editorConfig!: AngularEditorConfig;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        content: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddSabloaneComponent>,
        private sabloaneService: SabloaneService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.sabloaneService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const sablon = {
            name: this.form.get('name')?.value,
            content: this.form.get('content')?.value,
        };

        this.sabloaneService
            .addSablon(sablon)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();
    }
}
